import mutation from './mutation.graphql.js'
import { useMutation } from 'Data/Api.js'
import { useDataValue } from 'Simple/Data.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()

  let location_id = useDataValue({
    context: 'tab',
    viewPath: props.viewPath,
    path: 'selected.calendar_settings.location_id',
  })

  return async function onSubmit({ args }) {
    let mutationResponse = await executeMutation({
      object: {
        location_id,
        [args.key]: args.value,
      },
      columns_to_update: [args.key],
    })

    if (mutationResponse.error) {
      notify(notifyError('Something went wrong'))
    } else {
      notify(notifySuccess('Settings updated successfully'))
    }
  }
}
